<template>
    <div class="contract">
        <div class="searchPart">
            <div style="display:flex;align-items: center;">
                <el-input v-model="name" placeholder="模板名称"></el-input>
<!--                <el-input v-model="orderType" placeholder="订单类型"></el-input>-->
                <el-select v-model="orderType" clearable placeholder="订单类型">
                    <el-option value="PRINT" label="打印"></el-option>
                    <el-option value="SHOP" label="商品"></el-option>
                    <el-option value="SERVICE" label="服务"></el-option>
                </el-select>
                <el-button class="searchBtn" @click="search">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="reset">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
            <div class="toolRight">
<!--                <el-button type="text" size="small" @click="toDialog('add')">新增</el-button>-->
                <el-button type="primary" size="small" @click="toDialog('add')"><i class="el-icon-circle-plus-outline"></i>添加</el-button>
            </div>
        </div>
        <div class="contractTable">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                class="tableContent"
            >
                <el-table-column
                    prop="name"
                    label="模板名称"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                    width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="orderTypeCn"
                    label="订单类型"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="attachmentName"
                    label="模板附件"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
<!--                    <template slot-scope="scope">
                        <a
                            style="font-size: 12px"
                            href="static/pdf/打印合同模板.pdf"
                            download="生产合同.pdf"
                        >打印合同模板.pdf</a
                        >
                    </template>-->
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="创建时间"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="number"
                    label="合同份数"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <p v-text="`${ scope.row.number }份`"></p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="toDialog('edit',scope.row.uuid)">编辑</el-button>
                        <el-button type="text" size="small" @click="remove(scope.row.uuid)">删除</el-button>
<!--                        <a :href="scope.row.attachmentUrl" :download="scope.row.attachmentUrl"><el-button type="text" size="small">下载</el-button></a>-->
                        <a href="JavaScript:void(0)" @click="download(scope.row.attachmentUrl,scope.row.attachmentName)"><el-button type="text" size="small">下载</el-button></a>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total"
                class="pagination"
            >
            </el-pagination>
        </div>


        <!--添加/编辑模板弹出框-->
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            v-loading="loading"
            width="800px">
            <div class="dialogBoxClass">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="模板名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入模板名称"></el-input>
                    </el-form-item>
                    <el-form-item label="订单类型" prop="orderType">
                        <el-select v-model="form.orderType" placeholder="请选择">
                            <el-option
                                v-for="item in orderTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模板附件" prop="attachmentUrl">
                        <el-upload
                            class="avatar-uploader"
                            action="/service-center/upload/file/single"
                            :file-list="fileList"
                            :on-error="handleFileError"
                            :on-change="handleChange"
                            :on-success="handleFileSuccess">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                        <!--                        <p class="el-upload__tip" style="font-size: 13px;line-height: normal;">请上传 590 * 375 的图片，且不超过2M</p>-->
                    </el-form-item>
                    <el-form-item label="合同份数" prop="number">
                        <el-input-number v-model="form.number" :min="1" :max="10" ></el-input-number>
                    </el-form-item>
                    <el-form-item class="submitButtonGroup">
                        <el-button type="primary" @click="submitForm">提交</el-button>
                        <el-button @click="dialogVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import {
    deleteContractTemplate, getContractOrderTypes,
    getContractTemplateInfo,
    getContractTemplateList,
    saveContractTemplate,
    updateContractTemplate
} from "../../utils/interface";

export default {
    name: "contract",
    data() {
        return {
            name: "",
            orderType: "",
            total: 0,
            current: 0,
            pageSize: 10,
            type: '',
            fileList: [],
            tableData: [],
            orderTypeOptions: [],
            title: '',
            loading: false,
            form: {
                uuid: '',
                name: '',
                orderType: '',
                number: '1',
                attachmentUrl: '',
                attachmentName: '',
            },
            rules: {
                name: [{required: true, message: '请输入模板名称', trigger: 'blur'}],
                orderType: [{required: true, message: '请选择订单类型', trigger: 'blur'}],
                number: [{required: true, message: '请输入合同份数', trigger: 'blur'}],
                attachmentUrl: [{required: true, message: '请上传附件', trigger: 'blur'}],
            },
            dialogVisible: false
        };
    },
    created() {
        this.search();
        this.getOrderTypeList();
    },
    methods: {
        getOrderTypeList() {
          getContractOrderTypes().then((res) => {
            if(res.success) {
                this.orderTypeOptions = res.data;
            }
          });
        },

        search() {
            let params = {
                name: this.name,
                orderType: this.orderType,
                current: this.current,
                pageSize: this.pageSize
            };
            getContractTemplateList(params).then((res) => {
                this.current = res.current;
                this.total = res.total;
                this.tableData = res.list;
            });
        },
        reset() {
            this.name = '';
            this.orderType = '';
            this.current = 1;
            this.search();
        },
        // 分页
        handleCurrentChange(val) {
            this.current = val;
            this.search();
        },
        // 点击打开添加/编辑模板弹出框
        toDialog(type, uuid) {
            this.type = type
            this.dialogVisible = true
            this.form = {
                name: '',
                orderType: '',
                number: ''
            }
            this.fileList = [];

            if (type === 'add') {
                this.title = '添加模板'
            } else {
                this.title = '编辑模板'
                getContractTemplateInfo(uuid).then((res) => {
                    if (res.success) {
                        this.form = res.data;
                        this.fileList.push({name:this.form.attachmentName,url:this.form.attachmentUrl})
                    }
                });
            }
        },

        remove(uuid) {
            this.$confirm('确定要删除该模板吗' + '?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteContractTemplate(uuid).then((res) => {
                    if (res.success) {
                        this.$message.success("删除成功");
                        this.search()
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });

        },

        // 模板附件
        handleFileSuccess(res, file) {
            // this.fileList.push(res);
            this.$set(this.form, 'attachmentUrl', res.url);
            this.$set(this.form, 'attachmentName', res.name);
            this.$refs.ruleForm.validateField('attachmentUrl');
        },

        handleChange(file, fileList) {
            if (fileList.length > 0) {
                this.fileList = [fileList[fileList.length - 1]]
            }
        },

        handleFileError(err, file, fileList) {
          this.$message.error(err);
        },

        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    if (this.type === 'edit') {
                        updateContractTemplate(this.form, this.form.uuid).then((res) => {
                            if (res.success) {
                                this.$message.success("编辑成功");
                                this.dialogVisible = false;
                                this.search()
                            } else {
                                this.$message.error(res.message);
                            }
                            this.loading = false
                        });
                    } else {
                        saveContractTemplate(this.form).then((res) => {
                            if (res.success) {
                                this.$message.success("保存成功");
                                this.dialogVisible = false;
                                this.search()

                            } else {
                                this.$message.error(res.message);
                            }
                            this.loading = false
                        });
                    }
                    this.type = ''
                } else {
                    this.dialogVisible = true;
                    this.loading = false
                    // return false;
                }
            });
        },

        download(url,name) {
            // 用fetch发送请求
            fetch(url).then((res) => {
                res.blob().then((blob) => {
                    const blobUrl = window.URL.createObjectURL(blob);
                    // 这里的文件名根据实际情况从响应头或者url里获取
                    const filename = name;
                    const a = document.createElement('a');
                    a.href = blobUrl;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            });
        }
    }
};
</script>

<style lang="less" scoped>
.searchPart {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    /deep/ .el-input {
        width: initial;
        margin-bottom: 22px;
        margin-right: 30px;
    }

    /deep/ .el-input__inner {
        width: 242px;
        height: 35px;
        min-height: 35px;
        font-size: 12px;
        color: #999999;
        background-color: #f2f4f7;
        border: 1px solid #f2f4f7;
        border-radius: 5px;

        &:hover,
        &:focus {
            background-color: #fff;
            border: 1px solid #108ee9;
        }
    }

    /deep/ .el-input__prefix {
        top: -3px;
    }

    /deep/ .el-input__suffix {
        top: 2px;
    }

    /deep/ .el-button {
        display: block;
        line-height: 35px;
        padding: 0;
        height: 35px;
    }

    .searchBtn {
        width: 82px;
        background: #3d7fff;
        border: none;
        border-radius: 15px;
        font-size: 14px;
        color: #ffffff;
        margin-bottom: 22px;
    }

    .resetBtn {
        color: #333333;
        margin-bottom: 22px;
    }
}

.contract {
    padding: 20px;
}

.contractTable {
    .tableContent {
        min-height: 650px;
    }
}

.pagination {
    margin-top: 20px;
    text-align: right;
}

.toolRight{
    button{
        width: 83px;
        height: 30px;
        background: rgba(21, 126, 251, 1);
        border: none;
        border-radius: 15px;
        font-size: 13px;
        color: #fff;
        i{
            padding-right: 5px;
        }
        &:hover{
            background: #61a2f0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/contract/moduleManage.vue